import {styled} from "@mui/material/styles"
import Typography from "@mui/material/Typography"

export const MobileTitle = styled(Typography)<{component: "h1"}>`
    font-family: ${({theme: {colours}}) => colours.typography.subtitle2.fontFamily};
    font-weight: ${({theme: {colours}}) => colours.typography.subtitle2.fontWeight};
    font-size: ${({theme: {colours}}) => colours.typography.subtitle2.fontSize};
    line-height: ${({theme: {colours}}) => colours.typography.subtitle2.lineHeight};
    text-transform: ${({theme: {colours}}) => colours.typography.subtitle2.textTransform};
    letter-spacing: ${({theme: {colours}}) => colours.typography.subtitle2.letterSpacing};
    color: ${({theme: {colours}}) => colours.palette.text.primary};
`
export default MobileTitle
